import {Text} from '@pixi/react';
import {GlowFilter} from 'pixi-filters';
import {TextStyle} from 'pixi.js';
import {useCallback, useMemo, useState} from 'react';
import {LinkSprite} from './LinkSprite';
import {useActiveEditMode, useIsPopupEnabled, useNodePopupLocation} from '../state/networkEditStore';
import {useDeleteLink, useNetworkNodes} from '../state/networkHooks';
import {NodeId} from '../state/networkStore';
import {useDesignActive} from '../state/uiStore';
import {LinkRelationship} from '../SupplyChainPayloadTypes';

interface LinkSpriteProps {
    relationship: LinkRelationship,
    nodeAId: NodeId,
    nodeBId: NodeId,
}

const glow = new GlowFilter({distance: 20, outerStrength: 10, alpha: 1, color: 0xff0000});

export function DesignLink({nodeAId, nodeBId, relationship}: LinkSpriteProps) {
    const [hovering, setHovering] = useState<boolean>(false);
    const nodes = useNetworkNodes();
    const deleteLink = useDeleteLink();
    const designModeActive = useDesignActive();
    const activeEditMode = useActiveEditMode();
    const nodePopupLocation = useNodePopupLocation();
    const isPopupEnabled = useIsPopupEnabled();

    const middle = useMemo(() => {
        return {
            x: nodes[nodeAId].x + (nodes[nodeBId].x - nodes[nodeAId].x) / 2,
            y: nodes[nodeAId].y + (nodes[nodeBId].y - nodes[nodeAId].y) / 2,
        };
    }, [nodeAId, nodeBId, nodes]);

    const removeLink = useCallback(() => {
        deleteLink(nodeAId, nodeBId);
    }, [deleteLink, nodeAId, nodeBId]);

    const canRemove = hovering && !(nodePopupLocation.mantine || nodePopupLocation.pixi) && isPopupEnabled;
    // console.log(`DesignLink - designModeActive: ${designModeActive}, activeEditMode: ${activeEditMode}, hovering:${hovering}, isPopupEnabled:${isPopupEnabled} canRemove:${canRemove}`, nodePopupLocation);

    return <>
        <LinkSprite
            nodeA={nodes[nodeAId]} nodeB={nodes[nodeBId]}
            relationship={relationship}
            filters={canRemove ? [glow] : []}
            eventMode={'none'} // we don't want eventMode.auto to grab events when dragging over elements.
        />
        {designModeActive && activeEditMode === 'none' && // don't render when dragging player-node
            <Text text="Remove?" style={new TextStyle({
                align: 'center',
                fontFamily: 'Roboto Variable',
                fontSize: '15pt',
                fill: ['#ffffff'],
                stroke: '#ffffff',
                strokeThickness: 1,
                letterSpacing: 2,
            })} {...middle} anchor={.5}
            eventMode={'static'}
            onclick={removeLink}
            onmouseenter={() => setHovering(true)}
            onmouseleave={() => setHovering(false)}
            alpha={canRemove ? 1 : 0}
            />
        }
    </>;
}
